// For Vite, we need to use import.meta.env instead of process.env
// Environment variables must be prefixed with VITE_ instead of NEXT_PUBLIC_

export const SUPABASE_URL =
  import.meta.env.VITE_ENV === "dev"
    ? import.meta.env.VITE_DEV_SUPABASE_URL
    : import.meta.env.VITE_ENV === "staging"
    ? import.meta.env.VITE_STAGING_SUPABASE_URL
    : import.meta.env.VITE_SUPABASE_URL;

console.log("SUPABASE_URL", SUPABASE_URL);

export const SUPABASE_ANON_KEY =
  import.meta.env.VITE_ENV === "dev"
    ? import.meta.env.VITE_DEV_SUPABASE_ANON_KEY
    : import.meta.env.VITE_ENV === "staging"
    ? import.meta.env.VITE_STAGING_SUPABASE_ANON_KEY
    : import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log("SUPABASE_ANON_KEY", SUPABASE_ANON_KEY);

export const STRIPE_KEY = import.meta.env.VITE_ENV === "dev"
  ? import.meta.env.VITE_DEV_STRIPE_KEY
  : import.meta.env.VITE_STRIPE_KEY;

console.log("STRIPE_KEY", STRIPE_KEY);

// Check for backend_url query parameter first
const getCloudflareUrlFromQuery = () => {
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    return params.get("backend_url");
  }
  return null;
};

export const CLOUDFLARE_URL = getCloudflareUrlFromQuery() ?? (
  import.meta.env.VITE_ENV === "dev"
    ? import.meta.env.VITE_DEV_CLOUDFLARE_URL :
    (import.meta.env.VITE_ENV === "staging")
      ? import.meta.env.VITE_STAGING_CLOUDFLARE_URL
      : import.meta.env.VITE_CLOUDFLARE_URL
);

console.log("CLOUDFLARE_URL", CLOUDFLARE_URL);

export const DISCORD_OAUTH_URL = import.meta.env.VITE_CLOUDFLARE_URL + "/discord/link";